import { createContext, use } from 'react'

import type { CurrentSite } from './current-site'

/** How the shell shows the site a Super User acts on (110552); given by `CurrentSiteProvider`. */
export interface ActingSiteDisplay {
  /** Shows that site's name and branding in place of the address's own, or the address's own again for `null`. */
  readonly show: (site: CurrentSite | null) => void
  /** Reads that site again after a save of a site, as `useRefreshCurrentSite` asks; `null` to stop. */
  readonly setRefresher: (refresh: (() => Promise<void>) | null) => void
}

// Outside a provider there is no shell to show it in.
const noDisplay: ActingSiteDisplay = { show: () => undefined, setRefresher: () => undefined }

export const ActingSiteDisplayContext = createContext<ActingSiteDisplay>(noDisplay)

/** Shows the site a Super User acts on in the shell, in place of the address's own. Sign-in keeps the address's own options. */
export function useActingSiteDisplay(): ActingSiteDisplay {
  return use(ActingSiteDisplayContext)
}
